<template>
  <div class="news_details_wrap news-detail-page">
    <PCNavbar selectIndex="4-2"/>
    <MobileNavBar :currentActive="3"/>
    <div class="news_content">
      <el-breadcrumb class="news_bread" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>

      <article class="news_article">
        <header class="news_article_header">
          <h1 class="news_title">
            郭店街道办事处新能源充电桩场站落地投用
          </h1>
          <div class="news_meta">
            <span class="news_meta_item">来源：山东智能工业装备公司</span>
            <span class="news_meta_sep">·</span>
            <span class="news_meta_item">投稿时间：2026-09-16</span>
          </div>
        </header>

        <div class="article_body">
          <p class="lead">
            2026年9月16日，我司与郭店街道办事处合作建设的新能源充电桩场站正式落地投用。项目结合场地实际使用需求，完成充电设备安装及配套建设，为机关办公及周边新能源汽车出行提供更加便捷、高效的充电服务。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.cover"
              alt="郭店街道办事处"
            >
            <figcaption class="figure_caption">郭店街道办事处</figcaption>
          </figure>

          <h2 class="section_title">一、因地制宜，完成场站建设</h2>

          <p class="body_paragraph">
            项目实施过程中，我司根据现场环境及车辆充电需求，对设备选型、安装位置、供电条件及运行安全等环节进行综合规划，并完成充电设备安装、调试及系统接入，确保设备稳定投入使用。场站充电桩安装整齐、管线布局规范，具备智能扫码充电与实时运行监测能力。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img3"
              alt="郭店街道办事处充电桩设备"
            >
            <figcaption class="figure_caption">郭店街道办事处充电桩设备</figcaption>
          </figure>

          <h2 class="section_title">二、便捷充电，服务绿色出行</h2>

          <p class="body_paragraph">
            场站投用后，周边新能源车辆可就近补能。现场车辆充电运行平稳，设备支持快充服务，并具备实时功率监测、充电安全防护等功能，进一步提升了用户充电体验与运行可靠性。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img1"
              alt="场站车辆充电实况"
            >
            <figcaption class="figure_caption">场站车辆充电实况</figcaption>
          </figure>

          <figure class="figure_block figure_block--phone figure_block--end">
            <img
              class="article_img"
              :src="images.img2"
              alt="充电运行监测界面"
            >
            <figcaption class="figure_caption">充电运行监测界面</figcaption>
          </figure>

          <p class="body_paragraph">
            该项目的落地进一步完善了区域新能源充电基础设施，为机关办公及周边群众绿色出行提供了便利，也为我司新能源充电设备在公共服务场景中的应用积累了实践经验。未来，我司将持续推进新能源充电基础设施建设，为更多公共场所及企事业单位提供安全、稳定、智能的充电解决方案。
          </p>
        </div>
      </article>
    </div>

    <div class="news_detail_page_foot">
      <CallMe/>
      <MobileCallme/>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/report_list/SpaNav.vue'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
  data () {
    return {
      images: {
        cover: require('@/assets/images/news-list/news9/cover.jpg'),
        img1: require('@/assets/images/news-list/news9/image1.jpg'),
        img2: require('@/assets/images/news-list/news9/image2.jpg'),
        img3: require('@/assets/images/news-list/news9/image3.jpg'),
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@/assets/styles/news-detail-responsive.scss';

.news-detail-page .figure_block--phone {
  .article_img {
    width: auto;
    max-width: 360px;
    margin: 0 auto;
    border-radius: 16px;

    @media screen and (max-width: 768px) {
      max-width: 280px;
    }
  }
}
</style>
